module.exports = __webpack_public_path__ + "assets/images/ert_1.3f8f1da8b9dcbb51da282efdf744da64.png";